var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 29.5,
    rx: 6,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.75C5 13.2312 6.23122 12 7.75 12C9.26878 12 10.5 13.2312 10.5 14.75C10.5 16.2688 9.26878 17.5 7.75 17.5C6.23122 17.5 5 16.2688 5 14.75ZM7.75 13.5C7.05964 13.5 6.5 14.0596 6.5 14.75C6.5 15.4404 7.05964 16 7.75 16C8.44036 16 9 15.4404 9 14.75C9 14.0596 8.44036 13.5 7.75 13.5Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.75C12 13.2312 13.2312 12 14.75 12C16.2688 12 17.5 13.2312 17.5 14.75C17.5 16.2688 16.2688 17.5 14.75 17.5C13.2312 17.5 12 16.2688 12 14.75ZM14.75 13.5C14.0596 13.5 13.5 14.0596 13.5 14.75C13.5 15.4404 14.0596 16 14.75 16C15.4404 16 16 15.4404 16 14.75C16 14.0596 15.4404 13.5 14.75 13.5Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 12C20.2312 12 19 13.2312 19 14.75C19 16.2688 20.2312 17.5 21.75 17.5C23.2688 17.5 24.5 16.2688 24.5 14.75C24.5 13.2312 23.2688 12 21.75 12ZM20.5 14.75C20.5 14.0596 21.0596 13.5 21.75 13.5C22.4404 13.5 23 14.0596 23 14.75C23 15.4404 22.4404 16 21.75 16C21.0596 16 20.5 15.4404 20.5 14.75Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.14cd234b2455dc321c19ea031f8190d6.svg";
export { ForwardRef as ReactComponent };